import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import countries from './countries';
import './locales/countries/country-en.json';

interface Country {
    value: string;
    text: string;
    telPrefix: string;
    formattedLabel?: string;
    countryCode?: string;
}

function useLocalizedCountries(): Country[] {
    const { t } = useTranslation('back_royal');

    return useMemo(
        () =>
            countries
                .map(country => ({
                    value: country.value,
                    text: country.value ? t(`countries.country.${country.value}`) : '',
                    telPrefix: country.telPrefix,
                }))
                .sort((a, b) => a.text.localeCompare(b.text)),
        [t],
    );
}

export default useLocalizedCountries;
